/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const WarningIcon = /*#__PURE__*/ createSvgIcon(
  'WarningIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M2.331 17a.736.736 0 01-.665-.375.631.631 0 01-.093-.375.898.898 0 01.114-.396L9.354 3.062a.621.621 0 01.282-.27.849.849 0 01.728 0 .622.622 0 01.282.27l7.666 12.792c.07.125.108.257.115.396a.631.631 0 01-.094.375.841.841 0 01-.27.27.728.728 0 01-.395.105H2.331zm7.664-2.5c.212 0 .39-.072.536-.214a.714.714 0 00.219-.532.736.736 0 00-.215-.535.714.714 0 00-.53-.22.736.736 0 00-.536.215.714.714 0 00-.22.531c0 .212.072.39.215.536.143.146.32.219.531.219zm0-2.5c.212 0 .39-.072.536-.216a.72.72 0 00.219-.534v-2.5a.728.728 0 00-.215-.534.72.72 0 00-.53-.216.734.734 0 00-.536.216.72.72 0 00-.22.534v2.5c0 .212.072.39.215.534a.72.72 0 00.531.216z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default WarningIcon;
